import { SWRConfiguration } from "swr";
import useSWR from "@/hooks/useSWR";
import { PaginatedProxyListType, ProxyListFiltersQuery } from "../types";
import qs from "query-string";

export default function useProxyList(
  query: ProxyListFiltersQuery,
  options: SWRConfiguration & { enabled?: boolean } = { enabled: true }
) {
  return useSWR<PaginatedProxyListType>(
    {
      url: `/proxy/list/?${qs.stringify(query)}`,
      enabled: options.enabled,
    },
    options
  );
}
